import { Slider } from 'antd';
import styled from 'styled-components';

// Overrides some styling set in @metservice/antd-css-wrapper/dist/main.css
// for the antd Slider component
const StyledSlider = styled(Slider)`
    .ant-slider-handle {
        margin-left: 0;
    }
`;

export default StyledSlider;
